import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/auth/actions/appAction';
import { getRequestCheque } from 'apps/auth/actions/historyAction';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { isStatusFailedForBill, getStatusIconForBill } from 'apps/auth/helpers/historyUtils';
import { toLowerCase, resolveArguments } from 'apps/auth/helpers/utils';

import DetailsModal from '../DetailsModal';
import { TransactionsBlockSubheader, TransactionsFeedHeader, TransactionsFrame, TransactionsLineBottom } from '../styles';

const HistoryRecord = (props) => {
    const record = props.record;

    const showDetails = () => {
        props.getRequestCheque(props.record.id, props.record.newBill).then(() => {
            props.toggleModal(true, <DetailsModal />, false);
        });
    };

    const getCurrentMonth = (showYear, monthNumber, yearNumber) => {
        if (showYear) {
            return resolveArguments(props.messages['month_' + monthNumber + '_year'], yearNumber);
        } else {
            return props.messages['month_' + monthNumber];
        }
    };

    const getBillTitle = (recordForTitle) => {
        if (recordForTitle.incoming) {
            return recordForTitle.billIssuer;
        } else {
            return recordForTitle.billIssuer ? recordForTitle.billIssuer : `+${recordForTitle.fromPhone}`;
        }
    };

    const getRightInfoColor = (recordForInfoColor) => {
        if (isStatusFailedForBill(recordForInfoColor.status)) {
            return 'lightGray';
        } else if (recordForInfoColor.status === 'waiting' || recordForInfoColor.status === 'created') {
            return 'secondary';
        } else {
            return 'primary';
        }
    };

    const getBillAmount = (recordAmount) => {
        const prefixDirection = recordAmount.incoming ? '-' : '+';
        const currencyCode = recordAmount.currencyCode && typeof recordAmount.currencyCode === 'string' ? recordAmount.currencyCode.toLowerCase() : '';
        return (
            <Text
                variant="div"
                color={getRightInfoColor(recordAmount)}
                lineThrough={isStatusFailedForBill(recordAmount.status)}
                flexShrink="0"
                ellipsis
                leftSpacer
            >
                {`${isStatusFailedForBill(recordAmount.status) ? '' : prefixDirection} ${recordAmount.formatedAmount} `}
                <Text color={getRightInfoColor(recordAmount)} smallCaps>
                    {currencyCode}
                </Text>
            </Text>
        );
    };

    const getAvatar = (recordForAvatar) => {
        if (recordForAvatar.avatar) {
            return recordForAvatar.avatar;
        } else {
            return null;
        }
    };

    const getLetter = (recordLeter) => {
        if (recordLeter.avatar) {
            return null;
        } else if (recordLeter.firstLetter) {
            return recordLeter.firstLetter;
        } else {
            return ':)';
        }
    };
    return (
        <li>
            {props.addMonth && (
                <TransactionsBlockSubheader>
                    <Text variant="div" color="secondary" size="subheader">
                        {getCurrentMonth(record.showYear, record.monthNumber, record.yearNumber)}
                    </Text>
                </TransactionsBlockSubheader>
            )}
            <TransactionsFeedHeader showNotificationDot={record.newBill && record.incoming} onClick={showDetails}>
                <DiskBadge
                    src={getAvatar(record)}
                    diskText={getLetter(record)}
                    isDisabled={isStatusFailedForBill(record.status)}
                    flagName={record.direction === 'OUT' ? toLowerCase(record.toCountryCode) : toLowerCase(record.fromCountryCode)}
                />
                <TransactionsFrame>
                    <Row flex justify="between" indent="4px">
                        <Text color={isStatusFailedForBill(record.status) ? 'lightGray' : 'primary'} ellipsis>
                            {getBillTitle(record)}
                        </Text>
                        {getBillAmount(record)}
                    </Row>
                    <TransactionsLineBottom>
                        <Text size="secondary" color={isStatusFailedForBill(record.status) ? 'lightGray' : 'secondary'} ellipsis>
                            {record.comment}
                        </Text>
                        <Icon name={getStatusIconForBill(record.status)} size="16px" color={getRightInfoColor(record)} leftIndent="8px" />
                    </TransactionsLineBottom>
                </TransactionsFrame>
            </TransactionsFeedHeader>
        </li>
    );
};

HistoryRecord.propTypes = {
    record: PropTypes.shape({
        id: PropTypes.number.isRequired,
        createDate: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                year: PropTypes.number.isRequired,
                monthValue: PropTypes.number.isRequired,
                dayOfMonth: PropTypes.number.isRequired,
            }),
        ]).isRequired,
        toProviderName: PropTypes.string,
        toCardType: PropTypes.string,
        toAccount: PropTypes.string,
    }).isRequired,
};

const mapStateToProps = (state) => {
    return {
        messages: state.messages.pageMessages,
    };
};

export default connect(mapStateToProps, { toggleModal, getRequestCheque })(HistoryRecord);
